/**
 * Footer component for subscription form with action buttons.
 */

import { Typography, Button } from "@altimateai/lego";
import { Stack, LoadingButton } from "@altimateai/lego";

interface SubscriptionFormFooterProps {
  isEditMode: boolean;
  isSubmitDisabled: boolean;
  isLoading: boolean;
  isError: boolean;
  onCancel: () => void;
  onSubmit: () => void;
}

export const SubscriptionFormFooter = ({
  isEditMode,
  isSubmitDisabled,
  isLoading,
  isError,
  onCancel,
  onSubmit,
}: SubscriptionFormFooterProps) => {
  return (
    <Stack direction="column" gap="md" className="al-p-6 al-bg-background al-rounded-b-lg">
      {/* Error Message */}
      {isError && (
        <div className="al-bg-red-50 al-border al-border-red-200 al-rounded-lg al-p-3">
          <Typography variant="body" className="al-text-red-700 al-text-sm">
            Failed to {isEditMode ? "update" : "create"} subscription. Please try again.
          </Typography>
        </div>
      )}

      {/* Buttons */}
      <Stack direction="row" gap="md" justify="end">
        <Button variant="outline" onClick={onCancel}>
          Cancel
        </Button>
        <LoadingButton
          type="button"
          disabled={isSubmitDisabled}
          loading={isLoading}
          onClick={onSubmit}
          className="al-bg-blue-600 hover:al-bg-blue-700"
        >
          {isEditMode ? "Save changes" : "Create new subscription"}
        </LoadingButton>
      </Stack>
    </Stack>
  );
};
